import React, { useEffect, useState } from "react";

import { db } from "../../lib/firebaseCompat";

import EstimateTdDescription from "./EstimateTdDescription";
import EstimateTdDownload from "./EstimateTdDownload";
import EstimateTdStart from "./EstimateTdStart";
import Layout from "../shared/Layout";
import CardSearchTable from "../shared/CardSearchTable";
import { templatesTableHeaders } from "../../helpers/estimateTableHeaders";

const tooltip = `Select the template based on the industry or NAICS code to create an estimate. To view the estimate details, click the industry name.`;

const columns = [...templatesTableHeaders(), "Description", ""];
const columnNames = columns.map((c) => c.name);

const cardSearchPropDefaults = {
  columns,
  tooltip,
  header: "Select Template",
  placeholder: "Search by Industry, or NAICS Code",
  empty: "No estimate templates found.",
};
const initialPageLimit = 60;

export default function Templates() {
  const [templates, setTemplates] = useState([]);
  const [searchTerm, setSearchTerm] = useState();
  const [pageLimit, setPageLimit] = useState(initialPageLimit);

  const onSubmit = ({ search }) => {
    const term = search.toLowerCase();
    console.log(term);
    setSearchTerm(term);
  };

  const onLoadMore = () => {
    setPageLimit(pageLimit + initialPageLimit);
  };
  const page = {
    records: templates.length,
    initial: initialPageLimit,
    current: pageLimit,
  };

  const cardSearchProps = {
    onSubmit,
    onLoadMore,
    page,
    ...cardSearchPropDefaults,
  };

  useEffect(() => {
    const ref = db.collection("templates");
    const query = ref
      .where("active", "==", true)
      .orderBy("name")
      .limit(pageLimit);

    const search = searchTerm
      ? query.where("searchTerms", "array-contains", searchTerm)
      : query;

    const subscribe = (snapshot) => {
      const docs = snapshot.docs.map((doc) => {
        const estimate = { id: doc.id, ...doc.data() };
        return { estimate };
      });
      setTemplates(docs);
    };

    const unsubscribe = search.onSnapshot(subscribe);

    return unsubscribe;
  }, [db, pageLimit, searchTerm]);

  return (
    <Layout>
      <CardSearchTable {...cardSearchProps}>
        {templates.map(({ estimate }) => {
          return (
            <tr key={estimate.id}>
              <td>{estimate.naics}</td>
              <td>{estimate.name}</td>
              <td>{estimate.averageEmployees}</td>
              <EstimateTdDescription description={estimate.description} />
              <EstimateTdStart estimate={estimate} />
            </tr>
          );
        })}
      </CardSearchTable>
    </Layout>
  );
}
